import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EMPTY, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { EndpointService } from "./endpoint.service";

// These preferences are saved implicitly as the user navigates; a read-only preview rejects every write,
// so they are kept locally only rather than sent to fail.
@Injectable({
    providedIn: "root",
})
export class UserPreferencesService extends EndpointService {
    constructor(
        httpClient: HttpClient,
        private authService: AuthService,
    ) {
        super(httpClient);
    }

    setViewBySensor(isViewBySensor: boolean) {
        this.authService.setCurrentUserViewBySensor(isViewBySensor);
        if (this.authService.isReadonlyContext()) {
            return EMPTY;
        }
        return this.http
            .post(
                this.getApiUrl(
                    `UserPreferences/SetViewBySensor?isViewBySensor=${isViewBySensor}`,
                ),
                null,
            )
            .pipe(
                catchError((error) => {
                    return of();
                }),
            );
    }

    setEndPointId(endPointId: string) {
        this.authService.setCurrentUserEndPoint(endPointId);
        if (this.authService.isReadonlyContext()) {
            return EMPTY;
        }
        return this.http
            .post(
                this.getApiUrl(
                    `UserPreferences/SetEndPointId?endPointId=${endPointId}`,
                ),
                null,
            )
            .pipe(
                catchError((error) => {
                    return of();
                }),
            );
    }
}
